const ChairishContext = window.chairisher.context;

/**
 * @returns {string|undefined} Optional label identifying the current page type for livechat conversations
 */
export function getLiveChatHelpSuggestionTag() {
    return ChairishContext.LIVECHAT_HELP_SUGGESTION_TAG;
}
